import StoreContext from "contexts/StoreContext";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { apiService } from "service/ApiService";
import StorageService from "service/StorageService";

import { useTranslation } from "react-i18next";

const StoreSelect = () => {
  const {
    t,
  } = useTranslation();

  const [stores, setStores] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const fetchStores = async () => {
    try {
      const stores = await apiService.get("api/v1/stores");
      const storeOptions = stores.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      setStores(storeOptions);
      const selectedStore = StorageService.getSelectedStore();
      if (!selectedStore) {
        if (storeOptions.length !== 0) {
          setSelectedOption(storeOptions[0]);
          setStoreId(storeOptions[0].value);
          StorageService.setSelectedStore(storeOptions[0]);
        }
      } else {
        const selectedStoreIndex = storeOptions.findIndex((el) => el.value === selectedStore.value);
        if (selectedStoreIndex === -1) {
          setSelectedOption(storeOptions[0]);
          setStoreId(storeOptions[0].value);
          StorageService.setSelectedStore(storeOptions[0]);
          return;
        }
        setSelectedOption(selectedStore);
        setStoreId(selectedStore.value);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  // Handle changes in selected options
  const handleChange = (selected) => {
    StorageService.setSelectedStore(selected);
    setSelectedOption(selected);
    setStoreId(selected.value);
  };

  return (
    <>
      <Select
        isClearable={false}
        isSearchable={true}
        name="store-select"
        options={stores}
        value={selectedOption}
        onChange={handleChange}
        placeholder={t("messages.storeSelection")}
      />
    </>
  );
};

export default StoreSelect;
